import { render } from "./Progress.vue?vue&type=template&id=63098731"
import script from "./Progress.vue?vue&type=script&lang=js"
export * from "./Progress.vue?vue&type=script&lang=js"
script.render = render

export default script